import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import LiveControls from "./LiveControls.js";
import CastIcon from '@mui/icons-material/Cast';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import Playlist from "./Playlist";
import Settings from "./Settings";
import Library from "./Library.js";
import Templates from "./Templates.js";
import PermMediaIcon from '@mui/icons-material/PermMedia';
import SettingsIcon from '@mui/icons-material/Settings';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import Battery0BarIcon from '@mui/icons-material/Battery0Bar';
import Battery1BarIcon from '@mui/icons-material/Battery1Bar';
import Battery2BarIcon from '@mui/icons-material/Battery2Bar';
import Battery3BarIcon from '@mui/icons-material/Battery3Bar';
import Battery4BarIcon from '@mui/icons-material/Battery4Bar';
import Battery5BarIcon from '@mui/icons-material/Battery5Bar';
import Battery6BarIcon from '@mui/icons-material/Battery6Bar';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import BottomNavigation from '@mui/material/BottomNavigation';
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import InfoIcon from '@mui/icons-material/Info';
import { styled } from "@mui/material/styles";
import WifiSetupDialog from "./WifiSetupDialog.js"
import * as Server from './Server.js';
import {label} from './Dictionary.js';
import {theme_info} from './theme.js';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import Stats from './Stats.js'

const BottomNavigationAction = styled(MuiBottomNavigationAction)(
  "&.Mui-selected { color: " + theme_info("accent_color") + ";}"
);

function BatteryIcon({battery_level}) {

    if (battery_level < 0) {
        return <ElectricalServicesIcon />;
    } else if (battery_level === 0) {
        return <Battery0BarIcon />;
    } else if (battery_level <= 15) {
        return <Battery1BarIcon />;
    } else if (battery_level <= 30) {
        return <Battery2BarIcon />;
    } else if (battery_level <= 45) {
        return <Battery3BarIcon />;
    } else if (battery_level <= 60) {
        return <Battery4BarIcon />;
    } else if (battery_level <= 75) {
        return <Battery5BarIcon />;
    } else if (battery_level <= 90) {
        return <Battery6BarIcon />;
    } else {
        return <BatteryFullIcon />;
    }

}

function ResponsiveDrawer(props) {
  const searchParams = new URLSearchParams(document.location.search);
  const [value, setValue] = React.useState(0);
  const [activeTab, setActiveTab] = React.useState(<></>);
  const [batteryLevel, setBatteryLevel] = React.useState(0)
  const [status, setStatus] = React.useState("Unknown")
  const [isWIFISetupDialogOpen, setWIFISetupDialogOpen] = React.useState(false);
  const [valid_device, setValidDevice] = React.useState(false)
  const [show_templates_tab, setShowTemplatesTab] = React.useState(false)
  const [showStats, setShowStats] = React.useState(false)
  let interval;

  function SetBatteryLevel(battery_level, status)
  {
      setBatteryLevel(battery_level)
      setStatus(status)
  }

  function ShowWakeInfoAsNeeded() {

      return Server.GetDeviceDetails(searchParams.get("device_id"))
      .then((res) => {
          if (res.data.is_demo)
              setActiveTab(<LiveControls set_battery_level_fn={SetBatteryLevel}/>);
          else
              setActiveTab(<Playlist set_battery_level_fn={SetBatteryLevel}/>);
          setValidDevice(true)
          SetBatteryLevel(res.data.battery_level, res.data.status)
          if (!res.data.has_connected) {
              setWIFISetupDialogOpen(true)
              return false;
          }
          setWIFISetupDialogOpen(false)
          clearInterval(interval);
          setShowTemplatesTab(searchParams.get("client_id") ? true : false)
 
          return true;

      }).catch((err)=>{
        document.location = "https://roomeffect.co"
      })
  }

  React.useEffect(() => {
      
      ShowWakeInfoAsNeeded().then((has_connected) => {
          if (!has_connected) { 
            interval = setInterval(() => {
              ShowWakeInfoAsNeeded();
          }, 3000);
        }
      });
      return () => clearInterval(interval);

  }, []);

  const batteryStyle = {
    position: 'absolute',
    bottom: 11,
    right: 10,
  };

  const gradStyle = {
    position: 'fixed',
    backgroundImage: `linear-gradient(180deg, rgba(255,0,0,0) 0%, rgba(255,255,255,1) 100%)`,
    bottom: 84,
    height: `80px`,
    width: '100%',
    pointerEvents: 'none'
  };

  if (!valid_device)
    return (<></>)

  let nav_tabs = []
  nav_tabs.push(<BottomNavigationAction value={0} key="1" label={<span style={{fontSize:'12px'}}>{label("ID_Playlist")}</span>} icon={<SubscriptionsIcon />} />)
  nav_tabs.push(<BottomNavigationAction value={1} key="2" label={<span style={{fontSize:'12px'}}>{label("ID_LiveControls")}</span>} icon={<CastIcon />} />)
  nav_tabs.push(<BottomNavigationAction value={2} key="3" label={<span style={{fontSize:'12px'}}>{label("ID_Library")}</span>} icon={<PermMediaIcon />} />)
  if (show_templates_tab)
    nav_tabs.push(<BottomNavigationAction value={3} key="4" label={<span style={{fontSize:'12px'}}>{label("ID_Templates")}</span>} icon={<NewspaperIcon />} />)
  nav_tabs.push(<BottomNavigationAction value={4} key="5" label={<span style={{fontSize:'12px'}}>{label("ID_Settings")}</span>} icon={<SettingsIcon />} />)

  return (
    <Box sx={{ display: 'flex' }}>
      {showStats ? (
        <Stats isVisible={showStats} onDialogClick={()=>{setShowStats(false)}}></Stats>
      ) : (
        <></>
      )}
        <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100%)` },
          ml: { sm: `0px` },
        }}
      >
        <Toolbar>
        <img width="128" src={theme_info("logo_src")}></img>
          <div style={batteryStyle} onClick={()=>{setShowStats(true)}}>
          { status=="Unknown" ? (
            <WifiOffIcon sx={{marginRight:1}}/>
          ) : (
            <WifiIcon sx={{marginRight:1}}/>
          )}
          <BatteryIcon battery_level={batteryLevel} />
            </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: 0 }, flexShrink: { sm: 0 } }}
        aria-label="nav folders"
      >
      </Box>
      
        <Box
          component="main"
          sx={{ flexGrow: 2, p: 3, width: { sm: `calc(100%)` } }}
        >
        <Toolbar />
        {activeTab}
       </Box>
       <Box sx={{ position: 'fixed', backgroundColor:`white`, height:30, bottom: 0, left: 0, right: 0 }} ></Box>
       <Box sx={{ position: 'fixed', bottom: 28, left: 0, right: 0 }} >
        <Box sx={gradStyle}/>

        <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          switch(newValue) {
            case 0:
              setActiveTab(<Playlist set_battery_level_fn={SetBatteryLevel}/>)
            break;
            case 1:
              setActiveTab(<LiveControls set_battery_level_fn={SetBatteryLevel}/>)
            break;
            case 2:
              setActiveTab(<Library set_battery_level_fn={SetBatteryLevel}/>)
            break;
            case 3:
              setActiveTab(<Templates set_battery_level_fn={SetBatteryLevel}/>)
            break;
            case 4:
              setActiveTab(<Settings set_battery_level_fn={SetBatteryLevel}/>)
            break;
          }
          setValue(newValue)
        }}
      >
        {nav_tabs}
      
      </BottomNavigation>
    </Box>
    <WifiSetupDialog open={isWIFISetupDialogOpen}/>
    </Box>
  );
}

export default ResponsiveDrawer;
